/**
 * TimelineSkeleton
 *
 * A skeleton loading state for the Timeline component
 */

import React from 'react'
import { cn } from '@/lib/utils'

interface TimelineSkeletonProps {
  className?: string
  eventCount?: number
}

export const TimelineSkeleton: React.FC<TimelineSkeletonProps> = ({
  className,
  eventCount = 4
}) => {
  return (
    <div
      className={cn(
        'border-border bg-card my-4 flex animate-pulse flex-col overflow-hidden rounded-lg border shadow-sm transition-all',
        className
      )}
    >
      {/* Header */}
      <div className="flex items-center border-b p-3">
        <div className="flex items-center gap-2">
          <div className="size-4 rounded-full bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div className="h-4 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
        <div className="ml-auto h-6 w-20 rounded bg-gray-200 dark:bg-gray-700"></div>
      </div>

      <div className="p-0">
        <div className="relative">
          {[...Array(eventCount)].map((_, index) => (
            <div
              key={index}
              className={cn(
                'relative ml-4 border-l-2 border-blue-400 pb-2 dark:border-blue-600',
                index === eventCount - 1 ? 'border-l-0' : ''
              )}
            >
              {/* Timeline dot */}
              <div className="absolute -left-[5px] top-0 size-[10px] rounded-full bg-blue-400 dark:bg-blue-600" />

              <div className="pl-6 pt-1">
                <div className="flex items-start gap-2">
                  {/* Date */}
                  <div className="h-4 w-16 rounded bg-gray-200 dark:bg-gray-700"></div>

                  <div className="flex-1">
                    <div className="flex items-center gap-1">
                      {/* Chevron */}
                      <div className="size-4 rounded bg-gray-200 dark:bg-gray-700"></div>
                      {/* Title */}
                      <div className="h-4 w-32 rounded bg-gray-200 dark:bg-gray-700"></div>
                    </div>

                    {/* Description - show only for first item */}
                    {index === 0 && (
                      <div className="mt-2 space-y-2">
                        <div className="h-3 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
                        <div className="h-3 w-5/6 rounded bg-gray-200 dark:bg-gray-700"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
